<template>
  <el-select
    :value="currentValue"
    clearable
    filterable
    allow-create
    default-first-option
    size="mini"
    :placeholder="placeholder"
    class="tree-filter"
    @change="handleChange"
    @clear="handleClear"
    @visible-change="handleVisibleChange"
    :filter-method="handleFilterMethod"
  >
    <el-option
      v-for="(item, index) in searchOptions"
      :key="index"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import mockService from '../../mockService'

export default {
  name: 'TreeSearchSelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    searchType: {
      type: String,
      default: '1'
    },
    placeholder: {
      type: String,
      default: '请输入或选择文件夹名称'
    }
  },
  data () {
    return {
      currentValue: '',
      searchOptions: [],
      saveTimer: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.currentValue = val || ''
      }
    }
  },
  beforeDestroy () {
    if (this.saveTimer) {
      clearTimeout(this.saveTimer)
      this.saveTimer = null
    }
  },
  methods: {
    handleFilterMethod (value) {
      this.currentValue = value || ''
      this.$emit('input', this.currentValue)
      this.$emit('change', this.currentValue)
      this.scheduleSaveSearchLog(this.currentValue)
    },
    handleChange (value) {
      this.currentValue = value || ''
      this.$emit('input', this.currentValue)
      this.$emit('change', this.currentValue)
      this.saveSearchLog(this.currentValue)
    },
    handleClear () {
      this.currentValue = ''
      this.$emit('input', '')
      this.$emit('change', '')
    },
    handleVisibleChange (visible) {
      if (visible) {
        this.fetchSearchOptions()
      }
    },
    scheduleSaveSearchLog (value) {
      if (this.saveTimer) {
        clearTimeout(this.saveTimer)
      }
      this.saveTimer = setTimeout(() => {
        this.saveSearchLog(value)
      }, 300)
    },
    saveSearchLog (value) {
      const searchKey = (value || '').trim()
      if (!searchKey) return
      mockService.saveStoreDecorationSearchLog({
        searchType: this.searchType,
        searchKey
      }).then(() => {
        this.fetchSearchOptions()
      })
    },
    fetchSearchOptions () {
      mockService.getStoreDecorationSearchLogOptions({
        searchType: this.searchType
      }).then(res => {
        this.searchOptions = res.data || []
      })
    }
  }
}
</script>
